import '@fortawesome/fontawesome-free/css/all.css';
import './styles/fonts/lato/lato.css';
import './styles/fonts/roboto/roboto.css';
import './styles/fonts/roboto_mono/roboto-mono.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-tooltip/dist/react-tooltip.css';
import 'react-toastify/dist/ReactToastify.css';
import 'plyr-react/plyr.css';
import { registerLocale } from 'react-datepicker';
import 'moment/locale/ru';
import ru from 'date-fns/locale/ru';

import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { ThemeProvider } from 'app-providers';
import { TourProvider } from 'components/tour';
import { StoreProvider } from './hooks';
import { store } from './store/rootStore';
import { initializeSentry } from './sentry';
import { handleHashRedirect } from 'utils/handle-hash-redirect';

registerLocale('ru', ru);

initializeSentry();
handleHashRedirect();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <StoreProvider value={store}>
      <ThemeProvider>
        <TourProvider>
          <App />
        </TourProvider>
      </ThemeProvider>
    </StoreProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log comments (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
